// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1_HJn","fontsLoading":"card-module--fonts-loading--3HTdM","cardContent":"card-module--cardContent--356_Z"};